import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from "@angular/core";
import { Router } from "@angular/router";
import { BooleanInput } from "@angular/cdk/coercion";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { UserService } from "app/fuse-core/user/user.service";
import { User } from "app/core/models/auth/user";
import { Store } from "@ngrx/store";
import { AppState } from "app/core/store/reducers/app.reducer";
import { selectUser } from "app/core/store/selectors";
import { AuthService } from "app/core/services/auth.service";
import { FuseMediaWatcherService } from "@fuse/services/media-watcher";

@Component({
    selector: "user-menu",
    templateUrl: "./user-menu.component.html",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: "userMenu",
})
export class UserMenuComponent implements OnInit, OnDestroy {
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() showAvatar: boolean = true;
    user: User;
    isScreenSmall: boolean;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _userService: UserService,
        private _store: Store<AppState>,
        private _authService: AuthService,
        private _fuseMediaWatcherService: FuseMediaWatcherService
    ) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this._store.select(selectUser).subscribe((user) => {
            this.user = user;
            this._changeDetectorRef.markForCheck();
        });

        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({ matchingAliases }) => {
                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes("md");
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Sign out
     */
    signOut(): void {
        this._authService.logout();
        this._router.navigate(["/auth/logged-out"]);
    }

    public get isSSO() {
        return this._authService.isSSO;
    }

    onChangePassword() {
        this._router.navigate(["auth/change-password"]);
    }
    manageDelegation(){
      this._router.navigate(["delegations", "manage", this.user.username]);
    }
}
